import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all acuerdoColaboracion
export const getAcuerdoColaboracion = () => {
  return authClient().get(`${API}/acuerdoColaboracion?getDisabled=true`);
};

// Get acuerdoColaboracion by id
export const getAcuerdoColaboracionById = (id) => {
  return authClient().get(`${API}/acuerdoColaboracion/${id}`);
};

// Delete acuerdoColaboracion
export const deleteAcuerdoColaboracion = (id) => {
  return authClient().delete(`${API}/acuerdoColaboracion/${id}`);
};

// Create acuerdoColaboracion
export const postAcuerdoColaboracion = async (acuerdoColaboracion, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "acuerdoColaboracion");
    acuerdoColaboracion.logo = response?.data?.fileURL;
  }
  return authClient().post(`${API}/acuerdoColaboracion`, acuerdoColaboracion);
};

// Update acuerdoColaboracion
export const updateAcuerdoColaboracion = async (id, acuerdoColaboracion, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "acuerdoColaboracion");
    acuerdoColaboracion.logo = response?.data?.fileURL;
  }
  return authClient().put(`${API}/acuerdoColaboracion/${id}`, acuerdoColaboracion);
};

// Change status acuerdoColaboracion
export const changeStatusAcuerdoColaboracion = async (id, active) => {
  return authClient().put(`${API}/acuerdoColaboracion/change-status/${id}`, { active });
};

// Change order acuerdoColaboracion
export const changeOrderAcuerdoColaboracion = async (id, newOrder) => {
  return authClient().put(`${API}/acuerdoColaboracion/change-order/${id}`, {
    newOrder,
  });
};